'use client'
import type { FC } from 'react'
import React, { useState, useEffect, useContext } from 'react'
import cn from 'classnames'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useSelectedLayoutSegment } from 'next/navigation'
import classNames from 'classnames'
import { Home, MessageSquare, PenSquare, UserRound, Image as ImageIcon } from 'lucide-react'
import s from './style.module.scss'
import { AuthContext } from '@little-tavern/shared/src/authContext'
import { useConfig } from '@share/src/configContext'
import DollarIcon from '@/public/image/dollar.svg'
const commonNavClass = 'w-full flex flex-col items-center justify-center relative rounded cursor-pointer py-2.5 z-10 px-0.5 md:mr-7 text-xs'
const navIconActive = 'stroke-[url(#gradient)] dark:stroke-[url(#gradient-dark)]'
const svgIconActive = 'fill-[url(#gradient)] dark:fill-[url(#gradient-dark)]'
import useVisitorCheck from '@share/src/hook/useVisitorCheck'

export type INavBottomProps = {
}
// 展示过任务图标，隐藏后不再展示，下次启动小程序再展示
let showPublicTaskIcon = true
let lastIsReviewing = false
const NavBottom: FC<INavBottomProps> = ({
}) => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const selectedSegment = useSelectedLayoutSegment()
  const auth = useContext(AuthContext);
  const publish_task_switch = auth?.user?.publish_task_switch
  const { config } = useConfig()
  const [isReviewing, setIsReviewing] = useState(lastIsReviewing)

  useEffect(() => {
    if (config?.is_reviewing !== undefined) {
      const nextIsReviewing = !!config.is_reviewing
      lastIsReviewing = nextIsReviewing
      setIsReviewing(nextIsReviewing)
    }
  }, [config?.is_reviewing])
  // We no longer need to check for isLowBrowser as the CSS handles compatibility
  const navTxtActive = s.navTextGradient
  const { checkVisitor } = useVisitorCheck();

  // 开发环境测试
  // const getGlobalConfig = async () => {
  //   const res: any = await request('/config')
  //   setShowPublicTask(res.publish_task_switch)
  // }
  // useEffect(() => {
  //   process.env.NEXT_PUBLIC_ENV === 'dev' && getGlobalConfig()
  // }, [request])
  return (
    <>
      <svg width="0" height="0" className="absolute z-0 left-[-999px]">
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f472b6" /> {/* from-pink-400 */}
          <stop offset="100%" stopColor="#a855f7" /> {/* to-purple-500 */}
        </linearGradient>
        <linearGradient id="gradient-dark" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f472b6" /> {/* from-pink-400 */}
          <stop offset="100%" stopColor="#ec4899" /> {/* to-pink-500 */}
        </linearGradient>
      </svg>
      <div className="fixed md:hidden z-10 bottom-0 w-full left-0 bg-white dark:bg-[var(--nav-bg)] drop-shadow-u dark:drop-shadow-none dark:border-t dark:border-purple-500/10 text-[#181818] dark:text-white text-xs pb-[env(safe-area-inset-bottom)]">
        <div className='flex items-center justify-around'>
          <Link href={`/${lang}`} className={classNames(
            commonNavClass
          )}>
            <Home size={20} className={cn(selectedSegment === null && navIconActive)} />
            <span className={cn(selectedSegment === null && navTxtActive, 'mt-0.5')}> {t('app.nav.index')}</span>
          </Link>
          <Link href={`/${lang}/history/recent`} className={classNames(
            commonNavClass
          )}>
            <MessageSquare size={20} className={cn(selectedSegment === 'history' && navIconActive)} />
            <span className={cn(selectedSegment === 'history' && navTxtActive, 'mt-0.5')}>{t('app.nav.chat')}</span>
          </Link>
          {/* <Link href={`/${lang}/pay`} className={classNames(
            commonNavClass
          )}>
            <CreditCard size={20} className={cn(selectedSegment === 'pay' && navIconActive)} />
            <span className={cn(selectedSegment === 'pay' && navTxtActive, 'mt-0.5')}>{t('app.nav.pay')}</span>
          </Link> */}
          {isReviewing ? null : (<Link href={`/${lang}/earn`} className={classNames(
            commonNavClass
          )}>
            <svg className={cn(selectedSegment === 'earn' && svgIconActive, 'w-6 h-6')} viewBox="0 0 1024 1024" version="1.1" p-id="2861" width="200" height="200" fill="currentColor"><path d="M512 96c229.76 0 416 186.24 416 416S741.76 928 512 928 96 741.76 96 512 282.24 96 512 96z m0 64C317.589333 160 160 317.589333 160 512S317.589333 864 512 864 864 706.410667 864 512 706.410667 160 512 160z m32 97.216l0.021333 75.477333c73.706667 9.152 126.101333 48.853333 128.64 105.6l0.106667 4.373334h-64c0-24.661333-36.266667-48-98.133333-48-62.912 0-98.133333 19.712-98.133334 48 0 25.386667 30.741333 46.592 91.946667 47.914666l6.186667 0.085334c96.469333 0 162.133333 43.541333 162.133333 112 0 64.512-52.693333 101.994667-128.746667 110.250666l-0.021333 76.544h-64V712.96c-75.114667-8.533333-128.810667-48.533333-131.392-105.962667l-0.085333-4.373333h64c0 24.661333 36.309333 48.021333 98.133333 48.021333 62.890667 0 98.133333-19.733333 98.133333-48 0-25.386667-30.72-46.592-91.925333-47.936l-12.458667-0.128c-93.056-1.856-155.882667-44.992-155.882666-111.936 0-65.301333 53.973333-102.890667 131.498666-110.549333l-0.021333-74.901333h64z" p-id="2862"></path></svg>
            <span className={cn(selectedSegment === 'earn' && navTxtActive, 'mt-0.5')}>{t('app.nav.earn')}</span>
          </Link>
          )}
          {isReviewing ? null : <Link href={`/${lang}/create/myroles`} className={classNames(
            commonNavClass
          )} onClick={() => {showPublicTaskIcon = false}}>
            {publish_task_switch && showPublicTaskIcon && <div className='absolute top-0.5 mx-auto right-[-40px] left-0 text-xs px-1 bg-red-500 rounded-full text-white w-fit'>{t('app.gift')}</div>}
            <PenSquare size={20} className={cn(selectedSegment === 'create' && navIconActive)} />
            <span className={cn(selectedSegment === 'create' && navTxtActive, 'mt-0.5')}>{t('app.nav.create')}</span>
          </Link>}
          
          {isReviewing ? null : <Link href={`/${lang}/img/album`} className={classNames(
            commonNavClass
          )}>
            <ImageIcon size={20} className={cn(selectedSegment === 'img' && navIconActive)} />
            <span className={cn(selectedSegment === 'img' && navTxtActive, 'mt-0.5')}>{t('app.nav.album')}</span>
          </Link>}
          <Link href={`/${lang}/mine/setting`} className={classNames(
            commonNavClass
          )}>
            <UserRound size={20} className={cn(selectedSegment === 'mine' && navIconActive)} />
            <span className={cn(selectedSegment === 'mine' && navTxtActive, 'mt-0.5')}>{t('app.nav.mine')}</span>
          </Link>
        </div>
      </div>
    </>
  )
}

export default NavBottom
